import * as React from 'react';

import {
    Provider as RRP,
} from 'react-redux';

import {
    context as ctx,
} from 'one-ui-context';

/**
 * Represents the Provider properties
 */
export interface ProviderProps {
    /**
     * Reference to the Redux store instance
     */
    store: any;

    /**
     * Reference to the application wide
     * context instance
     */
    context: any;

    /**
     * List of child elements
     */
    children?: JSX.Element[] | JSX.Element;
}

/**
 * Provider to pass application wide data elements
 * like redux store, application context etc to
 * React components
 * @param props component properties
 */
export const Provider = (props: ProviderProps) => {
    const {
        store,
        context,
        children,
    } = props;

    // get the common context instance
    // for the one-view framework
    const Context = ctx();
    return (
        <RRP store={store}>
            <Context.Provider value={context}>
                {children}
            </Context.Provider>
        </RRP>
    );
};
